import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataDistributionType } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_DISTRIBUTION_TYPE =
  defineMasterdataEntity<MasterdataDistributionType>({
    name: 'distribution-type',
    responseKey: 'distributionTypes',
    displayWith: (d) => keyName(d.key, d.name),
    secondaryWith: (d) => d.display,
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-truck',
    title: 'Lieferartsuche',
    label: 'Lieferart',
    placeholder: 'Lieferart suchen...',
    columns: [
      {
        label: 'Lieferart',
        type: 'entity',
        icon: 'fa-regular fa-truck',
        value: (e) => keyName(e.key, e.name),
        secondary: (e) => e.display,
      },
      { label: 'Schlüssel', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
      {
        label: 'Frachtkosten',
        type: 'text',
        value: (e) => (e.freightCharge ? 'Ja' : 'Nein'),
      },
      {
        label: 'Frachtartikel',
        type: 'text',
        value: (e) => e.freightArticles?.join(', ') ?? null,
      },
      {
        label: 'Verkaufsorganisationen',
        type: 'text',
        value: (e) => e.salesOrgs?.join(', ') ?? null,
      },
      { label: 'Aktiv', type: 'text', value: (e) => (e.active ? 'Ja' : 'Nein') },
    ],
  });
